import './BetaBadge.css'

export function BetaBadge({ title = 'This feature is in beta — behaviour may change.' }: { title?: string }) {
  return (
    <span className="beta-badge" title={title}>
      Beta
    </span>
  )
}
